import { render } from "./MenuCol.vue?vue&type=template&id=1d4a333d&scoped=true"
import script from "./MenuCol.vue?vue&type=script&lang=js"
export * from "./MenuCol.vue?vue&type=script&lang=js"

import "./MenuCol.vue?vue&type=style&index=0&id=1d4a333d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d4a333d"]])

export default __exports__